document.addEventListener("DOMContentLoaded", function () {
    const accountIcon = document.getElementById("account-icon");
    const modalMenu = document.getElementById("mobile-account-menu");
    const body = document.body;
    const siteHeader = document.querySelector(".site-header");
    const pageWidth = document.querySelector(".site-header.site-header--stuck.site-header--opening .page-width");

    function toggleMenu(event) {
        if (window.innerWidth <= 767) {
            event.stopPropagation();
            const isVisible = modalMenu.classList.toggle("show");
            updateScrollLock(isVisible);
        }
    }

    function updateScrollLock(isVisible) {
       if (window.innerWidth <= 767 && isVisible) {
            body.style.overflow = 'hidden';
            modalMenu.scrollTop = 0;
            body.style.backgroundColor = "#ffffff";
        } else {
            body.style.overflow = '';
            body.style.backgroundColor = "";
        }
    }

    function closeMenuOnResize() {
        if (window.innerWidth > 767) {
            modalMenu.classList.remove("show");
            updateScrollLock(false);
        }
    }

    function handleOutsideClick(event) {
       if (event.target.closest("#account-icon")) {
            modalMenu.classList.toggle("show");
            updateScrollLock(modalMenu.classList.contains("show"));
            updateHeaderStyles();
        }
    }
    function updateHeaderStyles() {
        console.log("updateHeaderStyles 呼び出し");
    }



    accountIcon.addEventListener("click", toggleMenu);
    window.addEventListener("resize", closeMenuOnResize);
    document.addEventListener("click", handleOutsideClick);
    modalMenu.addEventListener("click", (event) => event.stopPropagation());

    const modalObserver = new MutationObserver(updateHeaderStyles);
    modalObserver.observe(modalMenu, { attributes: true, attributeFilter: ["class"] });

    const headerObserver = new MutationObserver(updateHeaderStyles);
    headerObserver.observe(siteHeader, { attributes: true, attributeFilter: ["class"] });

    updateHeaderStyles();
});

